// extracted by mini-css-extract-plugin
export default {"logo":"BankAccountPreview_logo__OZwss"};